// geoCountry.js
import axios from "axios";

let cachedCode = null;
let pendingPromise = null;

export function getCountryCodeOnce() {
  if (cachedCode) return Promise.resolve(cachedCode);

  if (!pendingPromise) {
    pendingPromise = axios
      .get("https://ipapi.co/json/")
      .then((res) => {
        cachedCode = res?.data?.country_code || null;
        return cachedCode;
      })
      .catch((err) => {
        console.error("Error fetching geo information:", err);
        cachedCode = null;
        return null;
      })
      .finally(() => {
        // щоб у випадку помилки можна було повторити пізніше
        pendingPromise = null;
      });
  }

  return pendingPromise;
}